import {
  Contactgegevens,
  Persoonsgegevens
} from "@cak-legacy/klantondersteuning-client";
import { SchemaToRequestMapper } from "./SchemaToRequestMapper";


const stringToDate = (stringDate: string) =>
  new Date(stringDate.replace(/(\d{2})\-(\d{2})\-(\d{4})/, "$3-$2-$1"));
export class CakKlantSchemaToRequestMapper extends SchemaToRequestMapper {
  

  protected override ContactgegevensFields: string[] = ["email", "telefoonnummer", "mobielnummer"];
  protected override MapContactGegevensField(contactgegevens: Contactgegevens, fieldName: string, fieldValue: string) {
    // The to lower case works because the model only has lower case properties
    // This fixes potential bugs where Email or telefoonNummer would not be mapped to the client model correctly.
    contactgegevens[fieldName.toLowerCase()] = fieldValue;
  }

  protected override PersoonsgegevensField: string[] = [
      "voornaam",
      "voorletters",
      "achternaam",
      "geslacht",
      "geboortedatum",
      "burgerservicenummer",
      "klantid"
    ];
    protected override MapPersoonsGegevensField(
      persoonsgegevens: Persoonsgegevens,
      fieldName: string,
      fieldValue: string
    ) {
      const lowercaseFieldName = fieldName.toLowerCase();
      if (lowercaseFieldName === "geboortedatum") {
        const geboortedatum = stringToDate(fieldValue);
        persoonsgegevens.geboortedatum = geboortedatum;
      } else if (lowercaseFieldName === "voorletters") {
        // We map voorletters to the predefined voornaam field in the persoonsgegevens when its filled.
        if (persoonsgegevens.voornaam) {
          // If voornaam has already been filled, don't overwrite it. We assume voornaam is more important
          return;
        }
        persoonsgegevens.voornaam = fieldValue;
      } else if (lowercaseFieldName === "klantid") {
        persoonsgegevens.klantId = fieldValue;
      } else {
        // The to lower case works because the model only has lower case properties other than klantId
        // This fixes potential bugs where burgerserviceNummer or Voorletters would not be mapped to the client model correctly.
        persoonsgegevens[lowercaseFieldName] = fieldValue;
      }
    }
}
